export default {
  brand: {
    fileShare: 'Partage de Fichiers'
  },
  common: {
    loading: 'Chargement...',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    download: 'Télécharger',
    downloadAll: 'Tout télécharger',
    downloadSelected: 'Télécharger la sélection',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Désélectionner',
    rootDirectory: 'Répertoire racine',
    createTime: 'Créé le',
    expireTime: 'Expire le',
    totalSize: 'Taille totale',
    noFiles: 'Aucun fichier'
  },
  share: {
    expired: 'Les fichiers partagés ont expiré',
    invalidLink: 'Lien de partage invalide',
    needVerifyCode: 'Veuillez entrer le code d\'extraction',
    verifyCodeLabel: 'Code',
    verifyCodePlaceholder: 'Entrez le code d\'extraction',
    extractFiles: 'Extraire les fichiers',
    extractionCodeError: 'Code d\'extraction incorrect',
    uuidRequestFailed: 'Échec de la demande de téléchargement',
    selectFilesFirst: 'Veuillez d\'abord sélectionner des fichiers',
    unknownError: 'Erreur inconnue'
  },
  error: {
    networkError: 'Erreur réseau',
    connectionFailed: 'Impossible de se connecter au dispositif de partage. Le dispositif est peut-être éteint, en veille ou la région de service a changé. Veuillez contacter le partageur.',
    outdatedLink: 'Impossible de se connecter au dispositif de partage. Un lien de partage obsolète a peut-être été utilisé. Veuillez demander au partageur de mettre à jour le système vers v2.0.10 ou supérieur, l\'APP vers v2.1.5 ou supérieur, et de recopier le lien de partage.',
    registryError: 'Erreur lors de la récupération des paramètres de pénétration réseau publique. Impossible de se connecter au service de Registre.',
    missingRegion: 'Il manque des informations de région de service au lien de partage. Veuillez demander au partageur de mettre à jour le système vers v2.0.10 ou supérieur, l\'APP vers v2.1.5 ou supérieur, et de recopier le lien de partage.'
  }
}
